<!-- 应收费用公司对网点 -->
<template>
  <div class="app-container">
    <!-- 操作栏 -->
    <el-card class="mb5">
      <div class="flx-between">
        <div class="feet-r">
          <!-- 添加/修改费用-->
          <el-popover placement="bottom-start" trigger="hover">
            <div class="feet">
              <!--批量添加费用-->
              <el-button
                size="small"
                type="primary"
                class="feet-btn"
                @click="operationBtn(1)"
              >{{ $t('receivablePayable.AddChargesInBulk') }}
              </el-button>
              <!--批量修改费用-->
              <el-button
                size="small" type="primary" class="feet-btn"
                @click="operationBtn(2)"
              >{{ $t('receivablePayable.batchModifyFees') }}
              </el-button>
              <!--导入添加费用-->
              <el-button
                size="small"
                type="primary" class="feet-btn"
                @click="importFees(1)"
              >{{ $t('receivablePayable.ImportAddCharges') }}
              </el-button>
              <!--导入修改费用-->
              <el-button
                size="small"
                type="primary" class="feet-btn"
                @click="importFees(2)"
              >{{ $t('receivablePayable.ImportModifyExpenses') }}
              </el-button>
              <!--快录-->
              <el-button
                size="small"
                type="primary" class="feet-btn"
                @click="quickRecord(1)"
              >{{ $t('receivablePayable.QuickRecord') }}
              </el-button>
              <!--批量导入快录-->
              <el-button
                size="small"
                type="primary" class="feet-btn"
                @click="quickRecord(2)"
              >{{ $t('receivablePayable.BatchImportClips') }}
              </el-button>
              <!--单号批量删除费用-->
              <el-button
                size="small"
                type="primary" class="feet-btn"
                @click="delOrder"
              >{{ $t('receivablePayable.BatchDeleteExpensesByOrderNo') }}
              </el-button>
            </div>
            <template #reference>
              <!-- 添加/修改费用-->
              <el-button
                v-permit:remove="'btn:aRGeneration:addCharge'"
                size="small"
              >
                {{ $t('receivablePayable.AddModifyExpenses') }}
              </el-button>
            </template>
          </el-popover>

          <!--生成应收-->
          <el-popover placement="bottom-start" trigger="hover">
            <el-button
              size="small"
              type="primary"
              @click="operationBtn(3)"
            >{{ $t('receivablePayable.GenerateReceivables') }}
            </el-button>
            <!-- 导入生成应收 -->
            <import-receivable-generation :fee-type-options="feeList" />
            <!--生成应收-->
            <template #reference>
              <el-button
                v-permit:remove="'btn:aRGeneration:generate'"
                size="small"
                type="primary"
              >{{ $t('receivablePayable.GenerateReceivables') }}
              </el-button>
            </template>
          </el-popover>

          <!--备注-->
          <el-button
            v-permit:remove="'btn:aRGenerationNew:remarks'"
            size="small"
            @click="operationBtn(5)"
          >{{ $t('receivablePayable.remark') }}
          </el-button>

          <!--导出-->
          <ExportButCmp
            :query-form="queryForm"
            :select-data="selectData"
            :current-columns="currentColumns"
          />

          <!--重新计算价格-->
          <el-popover placement="bottom-start" trigger="hover">
            <!--重新计算价格-->
            <div class="feet">
              <el-button
                size="small"
                type="primary"
                @click="operationBtn(7)"
              >{{ $t('receivablePayable.RecalculateThePrice') + '(' + $t('receivablePayable.Maximum100000') + ')' }}
              </el-button>
              <!--导入计算价格-->
              <el-button
                size="small"
                type="primary"
                class="feet-btn"
                @click="getImportTemplate(2)"
              >{{ $t('receivablePayable.ImportCalculatePrices') }}
              </el-button>
              <!--导入重量计算价格-->
              <el-button
                size="small"
                type="primary"
                class="feet-btn"
                @click="getImportTemplate(3)"
              >{{ $t('receivablePayable.ImportWeightsCalculatePrices') }}
              </el-button>
              <!--导入邮编计算-->
              <el-button
                size="small"
                type="primary"
                class="feet-btn"
                @click="postcodeCalculation(5)"
              >{{ $t('receivablePayable.ImportPostcodeCalculation') }}
              </el-button>
            </div>
            <template #reference>
              <el-button
                v-permit:remove="'btn:aRGenerationNew:RecalculateThePrice'"
                size="small"
              >{{ $t('receivablePayable.RecalculateThePrice') }}
              </el-button>
            </template>
          </el-popover>
          <!--删除-->
          <el-button
            v-permit:remove="'btn:aRGenerationNew:deleteRow'"
            size="small"
            type="danger"
            @click="deleteRow()"
          >{{ $t('receivablePayable.Delete') }}
          </el-button>

          <!--自定义栏目-->
          <CustomStatusBar
            :columns-data="TABLE_HEADER"
            :params="searchParams"
            :save-params="customParams"
            class="feet-btn"
            @updateColumns="updateColumns"
          />

          <!--推送快手揽收费-->
          <el-button
            v-permit:remove="'btn:aRGeneration:PushFastHandCharge'"
            size="small"
            type="primary"
            @click="onPushFastHandCharge"
          >{{ $t('orderCenterCont.PushFastHandCharge') }}
          </el-button>
        </div>
        <!--查询-->
        <el-button
          icon="el-icon-search"
          size="small"
          type="primary"
          @click="searchResources()"
        >{{ $t('receivablePayable.Search') }}
        </el-button>
      </div>
    </el-card>

    <!-- 分页table -->
    <el-card>
      <el-table
        :key="tableKey"
        ref="table"
        class="table-height"
        :height="tableHeightRow.height"
        :data="tableData"
        :row-key="getRowKey"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          :reserve-selection="true"
          align="center"
          type="selection"
          width="55"
        />
        <el-table-column :label="$t('operationCenter.ind')" align="center" width="60px">
          <template v-slot="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in currentColumns"
          :key="index"
          :align="item.fixed"
          :label="item.label"
          :prop="item.prop"
          :show-overflow-tooltip="true"
          :min-width="item.width"
        >
          <template v-slot="scope">
            <div
              v-if="item.prop === 'waybillNumber'"
              style="color: #00A551;cursor: pointer;"
              @click="editFee(scope.row)"
            >{{ scope.row[item.prop] }}
            </div>
            <div v-else-if="item.prop === 'businessType'">
              <!--揽收订单-->
              <span v-if="scope.row[item.prop] === 1">{{ $t('basicData.CollectionSystemBusiness') }}</span>
              <!--快递订单-->
              <span v-else>{{ `${$t('basicData.CourierSystemBusiness')}` }}</span>
            </div>
            <div v-else-if="item.prop === 'orderPackageType'">
              <span v-if="scope.row[item.prop] === 1">{{ $t('placeOrder.zhifa') }}</span> <!--直单-->
              <span v-if="scope.row[item.prop] === 2">{{ $t('placeOrder.CoPacking') }}</span> <!--合单-->
              <span v-if="scope.row[item.prop] === 3">{{ $t('basicData.other') }}</span> <!--其他-->
              <span v-if="scope.row[item.prop] === 4">{{ $t('placeOrder.big01') }}</span> <!--大件-->
              <span v-if="scope.row[item.prop] === 5">{{ $t('basicData.OnePieceMultipleOrders') }}</span> <!--一件多单-->
            </div>
            <div v-else-if="item.prop === 'collectType'">
              <span v-if="scope.row[item.prop] === 1">{{ $t('collectionCenter.dropOff') }}</span><!-- 上门交件 -->
              <span v-if="scope.row[item.prop] === 2">{{ $t('collectionCenter.doorPickUp') }}</span><!-- 上门揽收 -->
            </div>
            <div v-else-if="item.prop === 'expressType'">
              <span v-if="scope.row[item.prop] === 1">{{ $t('basicData.express') }}</span><!-- 特快 -->
              <span v-if="scope.row[item.prop] === 2">{{ $t('basicData.OrdinaryCourier') }}</span><!-- 普快 -->
              <span v-if="scope.row[item.prop] === 3">{{ $t('trajectory.postOffice') }}</span><!-- 邮局 -->
            </div>
            <div v-else-if="item.prop === 'collectionCategory'">
              <span v-if="scope.row[item.prop] === 0">{{ $t('basicData.OrdinaryPickUp') }}</span><!-- 普通揽收 -->
              <span v-if="scope.row[item.prop] === 1">{{ $t('basicData.StockingAndPickup') }}</span><!-- 备货揽收 -->
            </div>
            <div v-else-if="item.prop === 'feeSource'">
              <!--系统生成-->
              <span v-if="scope.row[item.prop] === 0">{{ $t('receivablePayable.SystemGenerated') }}</span>
              <!--快录生成-->
              <span v-else-if="scope.row[item.prop] === 1">{{ $t('receivablePayable.QuickRecordGeneration') }}</span>
              <!--其他-->
              <span v-else>{{ $t('basicData.other') }}</span>
            </div>
            <!--货物类型-->
            <div v-else-if="item.prop === 'cargoType'">
              <span>{{ CARGO_TYPE[scope.row[item.prop]] && CARGO_TYPE[scope.row[item.prop]].name || '' }}</span>
            </div>
            <!-- 对账单类型-->
            <!--            <div v-else-if="item.prop === 'statementType'">-->
            <!--              {{ EXPRESS_TYPE[scope.row.statementType] ? EXPRESS_TYPE[scope.row.statementType].label : '' }}-->
            <!--            </div>-->
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, ind) in getCurrentColumns"
          :key="ind + 100"
          :align="item.fixed"
          :label="item.label"
          :prop="item.prop"
          :show-overflow-tooltip="true"
          :min-width="item.width"
        >
          <template v-slot="scope">
            <div>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
        <!--备注-->
        <el-table-column
          :label="$t('basicData.remark')"
          :show-overflow-tooltip="true"
          align="left"
          prop="remark"
          width="200"
        >
          <template v-slot="scope">
            <div>{{ scope.row.remark }}</div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="getARGenerationTableData"
          @size-change="getARGenerationTableData"
        />
      </div>
    </el-card>

    <!--搜索-->
    <el-drawer
      :append-to-body="true"
      :title="$t('receivablePayable.Search')"
      :visible.sync="showSearch"
      custom-class="drawerClass"
      direction="rtl"
      size="50%"
    >
      <SearchForm
        :select-key="0"
        :handler-id="handlerId"
        @search="searchFun"
        @close="showSearch = false"
      />
    </el-drawer>

    <!--批量添加费用-->
    <el-drawer
      :append-to-body="true"
      :title="addType === 1 ? $t('receivablePayable.AddChargesInBulk') : $t('receivablePayable.FeeDetails')"
      :visible.sync="showBatchAdd"
      custom-class="drawerClass"
      direction="ltr"
      size="80%"
    >
      <batch-add-fee
        :key="batchAddKey"
        :type="1"
        :add-type="addType"
        :fee-type-option="feeList"
        :query-fee-param="queryFeeParam"
        :query-form="queryForm.params"
        :select-data="selectData"
        @saveForm="saveForm"
      />
    </el-drawer>

    <!--快录添加费用-->
    <el-drawer
      :append-to-body="true"
      :title="$t('receivablePayable.SnapshotFee')"
      :visible.sync="showAddSnapshotFee"
      custom-class="drawerClass"
      direction="ltr"
      size="80%"
    >
      <add-snapshot-fee
        :key="snapshotFeeKey"
        :expense-sub-list="expenseSubList"
        :fee-type-option="feeList"
        :query-fee-param="queryFeeParam"
        @saveFormSnapshot="saveFormSnapshot"
      />
    </el-drawer>

    <!--添加备注-->
    <el-dialog
      :append-to-body="true"
      :title="$t('receivablePayable.AddANote')"
      :visible.sync="showAddNotes"
      width="50%"
      @close="remarks = ''"
    >
      <el-input v-model="remarks" :rows="5" type="textarea" />
      <span slot="footer" class="dialog-footer">
        <!--取 消-->
        <el-button @click="saveRemarks(1)">{{ $t('basicData.Cancel') }}</el-button>
        <!--确 定-->
        <el-button type="primary" @click="saveRemarks(2)">{{ $t('basicData.determine') }}</el-button>
      </span>
    </el-dialog>

    <!--导入添加、 修改费用-->
    <el-dialog
      :title="expensesType === 1 ? $t('receivablePayable.ImportAddCharges') : $t('receivablePayable.ImportModifyExpenses')"
      :visible.sync="showModification"
      width="400px"
    >
      <div v-if="expensesType === 1">
        <import-add-fee @changeFeeList="changeFeeList" />
      </div>
      <div v-else-if="expensesType === 2">
        <batch-change @changeFeeList="changeFeeList" />
      </div>
    </el-dialog>

    <!--应收生成批次号提示-->
    <el-dialog
      :append-to-body="true"
      :title="$t('receivablePayable.tips')"
      :visible.sync="showGenerate"
      width="50%"
    >
      <div style="height: 40vh;overflow: hidden;">
        <div style="height: 100%;overflow: auto;">
          <!--对账批次生成成功！-->
          <div style="margin-bottom: 20px;">{{ $t('receivablePayable.ReconciliationBatchGenerationSuccessful') }}</div>
          <!--对账批次号：-->
          <div>{{ $t('receivablePayable.ReconciliationBatchNumber') }}
            <div v-for="(item, index) in batchNumber" :key="index" style="margin: 0 10px 5px 0;">
              <span>{{ item.replace('~', '\n') }}</span>
            </div>
          </div>
        </div>
        <textarea id="message5" />
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消-->
        <el-button @click="copyBatchNumber(1)">{{ $t('basicData.Cancel') }}</el-button>
        <!--复制批次号-->
        <el-button type="primary" @click="copyBatchNumber(2)">{{
          $t('receivablePayable.CopyTheBatchNumber')
        }}</el-button>
      </span>
    </el-dialog>

    <!--重新计算价格-->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('receivablePayable.RecalculateThePrice')"
      :visible.sync="recalculate"
      width="80%"
      @close="changePage(false)"
    >
      <recalculatePrice
        :key="showManage1"
        :calculation-type="calculationType"
        :get-param="queryForm.params"
        :import-data="importData"
        :select-data="selectData"
        @changePage="changePage"
      />
    </el-dialog>

    <!--删除费用-->
    <el-dialog
      :title="$t('receivablePayable.DeleteTheFee')"
      :visible.sync="showDeleteRow"
      width="500px"
    >
      <div>
        <!--注意：会删除所选费用类型的所有数据-->
        <div style="color: red;margin-bottom: 20px;">{{
          $t('receivablePayable.NoteAllDataSelectedChargeDeleted')
        }}
        </div>
        <div>
          <!--费用类型-->
          <span style="color: red">*</span>{{ $t('basicData.ExpenseType') }}：
          <el-select
            v-model="feeTypeName"
            :placeholder="$t('operationCenter.PleaseSelect')"
            clearable
            filterable
            style="width: 100%;"
          >
            <el-option
              v-for="item in feeList"
              :key="item.id"
              :label="item.displayName"
              :value="item.code"
            />
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消-->
        <el-button @click="saveDeleteRow(1)">{{ $t('basicData.Cancel') }}</el-button>
        <!--确 定-->
        <el-button type="primary" @click="saveDeleteRow(2)">{{ $t('basicData.determine') }}</el-button>
      </span>
    </el-dialog>

    <!--生成应收时间-->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('receivablePayable.SelectGenerateAccrualTime')"
      :visible.sync="generateReceivables"
      width="500px"
    >
      <el-form
        ref="receivableForm"
        size="small"
        :model="receivableForm"
      >
        <el-form-item
          :label="$t('receivablePayable.SelectGenerateAccrualDate')"
          prop="timeCollection"
          :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
        >
          <el-date-picker
            v-model="receivableForm.timeCollection"
            :end-placeholder="$t('operationCenter.endDate')"
            :start-placeholder="$t('operationCenter.startDate')"
            range-separator="-"
            style="width: 100%"
            size="small"
            type="daterange"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item
          :label="$t('receivablePayable.billType')"
          prop="statementType"
          :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
        >
          <el-select
            v-model="receivableForm.statementType"
            :placeholder="$t('operationCenter.PleaseSelect')"
            clearable
            size="small"
            filterable
            style="width: 100%;"
          >
            <el-option
              v-for="item in EXPRESS_TYPE"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!--取 消-->
        <el-button @click="determineReceivables(1)">{{ $t('basicData.Cancel') }}</el-button>
        <!--确 定-->
        <el-button type="primary" @click="determineReceivables(2)">{{ $t('basicData.determine') }}</el-button>
      </div>
    </el-dialog>

    <!--打开导入计算价格模板弹窗-->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('receivablePayable.RecalculateThePrice')"
      :visible.sync="showImportTemplate"
      width="500px"
    >
      <import-calculated-price
        :key="showImportTemplate"
        :calculation-type="calculationType"
        @importPrice="importPrice"
      />
    </el-dialog>
    <!--导入快录-->
    <el-dialog
      :title="$t('receivablePayable.BatchImportClips')"
      :visible.sync="showBatchImportClips"
      width="400px"
    >
      <batch-import-clips
        :key="snapshotImportClips"
        :outlets-list="outletsList"
        @importClips="importClips"
      />
    </el-dialog>

    <!--   按单号批量删除费用-->
    <el-dialog
      :title="$t('receivablePayable.BatchDeleteExpensesByOrderNo')"
      :visible.sync="showBatchDeleteExpensesByOrderNo"
      width="400px"
    >
      <BatchDelOrder
        :key="batchDeleteExpensesByOrderNo"
        :fee-type-option="feeList"
        @importDelOrder="importDelOrder"
      />
    </el-dialog>

    <!-- 批量修改费用 -->
    <ModifyFee
      ref="modifyFeeRef"
      :fee-type-option="feeList"
      :query-form="queryForm"
      :select-data="selectData"
      @close="searchFun"
    />
  </div>
</template>

<script>
import {
  apiFinancialExpressKwai,
  apiGenerateBillNumber,
  apiGetSubsByWaybillNumber,
  apiPayableSiteBatchFastInputFee,
  apiSetRemark,
  apiSiteExpenseDeleteFeeSub,
  apiSiteExpenseGetPage,
  apiPayableSiteExpenseDeleteFee
} from '@/api/finance/receivables';
import { apiCommonSite } from '@/api/logisticsOrders';
import { goFileUploadManagement } from '@/utils/goExportList.js';
import { cloneDeep } from 'lodash-es';
import { checkSameMonth, getIsAuth } from '@/views/finance/utils.js';
import SearchForm from '@/views/finance/receivableManagementSite/cmp/searchForm/index.vue';
import ImportCalculatedPrice from '../cmp/ImportCalculatedPrice.vue';
import batchAddFee from '../cmp/batchAddFee.vue';
import batchChange from '../cmp/batchChange.vue';
import recalculatePrice from '../cmp/recalculatePrice.vue';
import importAddFee from '../cmp/importAddFee.vue';
import addSnapshotFee from '../cmp/addSnapshotFee.vue';
import batchImportClips from '../cmp/batchImportClips.vue';
import ExportButCmp from '../cmp/ExportButCmp/index.vue';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import { WAYBILL_STATUS, ORDER_TYPE_LIST, BH_ORDER_TYPE_LIST } from '@/views/finance/enums.js';
import { TABLE_HEADER, QUERY_PARAMS, EXPRESS_TYPE } from '../utils';
import importReceivableGeneration from '../cmp/importReceivableGeneration.vue';
import { BILL_TYPE, CARGO_TYPE } from '@/views/finance/basicData/quotationManagement/cmp/utils';
import toolRequestClass from '@/views/finance/mixins/toolRequestClass';

export default {
  name: 'ExpressReceivables',
  components: {
    SearchForm,
    batchAddFee,
    recalculatePrice,
    ImportCalculatedPrice,
    batchChange,
    importAddFee,
    addSnapshotFee,
    batchImportClips,
    ExportButCmp,
    importReceivableGeneration,
    CustomStatusBar: () => import('@/components/customStatusBar/index.vue'),
    BatchDelOrder: () => import('../cmp/batchDelOrder.vue'),
    ModifyFee: () => import('../cmp/modifyFee.vue')
  },

  mixins: [estimateTableHeight, toolRequestClass],

  data() {
    const priceType = (rule, value, callback) => {
      // const reg = /(^[1-9]\d*(\.\d{1,5})?$)|(^0(\.\d{1,5})?$)/;
      const reg = new RegExp('(^[1-9]\\d*(\\.\\d{1,' + rule.suffix + '})?$)|(^0(\\.\\d{1,' + rule.suffix + '})?$)');
      const { required } = rule;
      if (!required) {
        if (!value) {
          return callback();
        } else {
          if (!reg.test(value)) {
            return callback(new Error(this.$i18n.t('basicData.IncorrectFormatting'))); // '格式不正确'
          } else {
            const valNum = Number(value);
            if (rule.max && (valNum >= rule.max)) {
              return callback(new Error(this.$i18n.t('basicData.MustBeLessThan') + `${rule.max}`)); // 必须小于
            } else {
              return callback();
            }
          }
        }
      } else {
        if (!value || (value.length === 0)) {
          return callback(new Error(this.$i18n.t('basicData.CannotBeEmpty'))); // '不能为空'
        }
        if (!reg.test(value)) {
          return callback(new Error(this.$i18n.t('basicData.IncorrectFormatting'))); // '格式不正确'
        } else {
          const valNum = Number(value);
          if (rule.max && (valNum >= rule.max)) {
            return callback(new Error(this.$i18n.t('basicData.MustBeLessThan') + `${rule.max}`)); // 必须小于
          } else {
            return callback();
          }
        }
      }
    };
    return {
      WAYBILL_STATUS,
      ORDER_TYPE_LIST,
      BH_ORDER_TYPE_LIST,
      CARGO_TYPE,
      EXPRESS_TYPE,
      queryForm: {
        orderDirection: 'DESC',
        orderProperty: '',
        pageNumber: 1,
        pageSize: 50,
        params: {
          ...QUERY_PARAMS
        }
      },
      handlerId: '', // 经办人
      total: 0,
      tableData: [],
      selectData: [],
      showSearch: false,
      showAddNotes: false,
      remarks: '',
      getCurrentColumns: [],
      showJournal: false,
      checkData: {},
      keyJournal: new Date().getTime(),
      tableKey: new Date().getTime(),
      selectedAmount: 0, // 已选金额
      showBatchAdd: false,
      batchAddKey: new Date().getTime(),
      showGenerate: false,
      batchNumber: [],
      priceType,
      recalculate: false,
      showManage1: new Date().getTime(),
      calculationType: 0,
      showDeleteRow: false,
      feeTypeName: '',
      rowSelectFlag: false,
      queryFeeParam: {},
      addType: 1, // 1: 单票添加费用 2：批量添加费用
      generateReceivables: false,
      receivableForm: {
        timeCollection: [], // 应收账单日期
        statementType: '' // 账单类型
      },
      showImportTemplate: false,
      importData: [],
      showModification: false,
      expensesType: 1,
      showAddSnapshotFee: false,
      snapshotFeeKey: new Date().getTime(),
      snapshotImportClips: new Date().getTime(),
      showBatchImportClips: false,
      expenseSubList: [],
      outletsList: [],
      TABLE_HEADER, // 自定义表头
      currentColumns: [],
      searchParams: {
        type: 0,
        menuEnum: 'companyToSite'
      },
      customParams: {
        templateField: '',
        templateName: '快递应收',
        type: 0,
        menuEnum: 'companyToSite',
        userId: ''
      },
      showBatchDeleteExpensesByOrderNo: false,
      batchDeleteExpensesByOrderNo: new Date().getTime()
    };
  },

  activated() {
    if (this.$route.params.id) {
      this.selectData = [];
      this.selectedAmount = 0;
      this.tableKey = new Date().getTime();
      this.getARGenerationTableData();
    }
  },
  created() {
    // 获取费用类型
    this.getExpenseTypeList({
      state: 1, // 状态（1启用，0禁用）
      attribute: 1 // 1 应收费用 2 应付费用
    });
    // 获取网点
    this.getSitePageList();
    // 主体
    this.getProviderPage();

    // 经办人是否存在禁用，如果禁用则只能查看当前当前登陆人
    {
      const isBool = getIsAuth('btn:aRGeneration:onlyAgent');
      if (isBool) {
        this.handlerId = this.$store.getters.userId;
      }
    }
  },
  methods: {
    // 更新自定义栏目columns
    updateColumns(list) {
      this.$nextTick(() => {
        this.currentColumns = cloneDeep(list);
        this.tableKey = new Date().getTime();
      });

      console.log(list, '列表呈现的columns');
    },

    /**
     * 导入邮编计算
     * @param type
     */
    postcodeCalculation(type) {
      this.calculationType = type;
      this.showImportTemplate = true;
      this.importData = [];
    },

    // 推送快手揽收费
    onPushFastHandCharge() {
      const selectedColumn = cloneDeep(this.selectData);
      const name = 'kwai';

      const query = {
        customerId: 0, // 客户只能是 kuai,才能有此操作
        waybillNumberList: ''
      };

      // 没有选中
      if (selectedColumn.length === 0) {
        this.$message.warning(this.$t('receivablePayable.KuaiFee'));
        return;
      }

      // 筛选出客户为 kuai 的（这里只能通过中文名称检测，不考虑同名情况，实际校验由后端完成）
      const arr = selectedColumn.filter(item => {
        return item.customerAlias === name;
      }).map(item => {
        // 设置客户
        query.customerId = item.customerId;
        return item.waybillNumber;
      });

      console.log(arr, 'kwai单号');
      // 选中的项没有 kuai
      if (arr.length === 0) {
        this.$message.warning(this.$t('receivablePayable.KuaiFee'));
        return;
      }

      query.waybillNumberList = arr.join(',');
      apiFinancialExpressKwai(query).then(res => {
        const { data } = res;
        const msg = Object.entries(data || {}).map(item => {
          const [key, value] = item;
          return key + '：' + value;
        }).join('；');
        this.$message({
          message: msg
        });
      }).catch(err => {
        console.error(err);
      });
    },

    // 导入快录
    importClips(data) {
      apiPayableSiteBatchFastInputFee(data).then(res => {
        if (res.code === 200) {
          // this.$message.success(this.$t('basicData.TheOperationSucceeded'));
          goFileUploadManagement(this);
          this.getARGenerationTableData();
          this.tableKey = new Date().getTime();
          this.showBatchImportClips = false;
        }
      });
    },
    /**
     * 快录费用
     * @param type  1 新增 2 导入
     */
    quickRecord(type) {
      if (type === 1) {
        if (this.selectData.length > 0) {
          this.queryFeeParam = cloneDeep(this.selectData[0]);
          this.queryFeeParam.waybillNumber = this.queryFeeParam.waybillNumber.replace('QR', '');
          this.queryFeeParam.id = null;
        } else {
          this.queryFeeParam = {
            id: null,
            waybillNumber: '', // 业务单号
            customerId: '', // 客户id
            customerAlias: '', // 客户别称
            providerId: '', // 业务主体id
            siteId: '', // 网点id
            siteName: '', // 网点名称
            chargeWeight: '', // 计费重量
            businessType: '', // 业务类型
            collectionCategory: '', // 揽收类型
            remark: '', // 备注
            isSynchronous: false
          };
        }
        this.showAddSnapshotFee = true;
        this.snapshotFeeKey = new Date().getTime();
      } else {
        this.showBatchImportClips = true;
        this.snapshotImportClips = new Date().getTime();
      }
    },
    // 分页获取站点
    getSitePageList() {
      const param = {
        pageNumber: 1,
        pageSize: 9999999,
        params: {
          siteStatus: undefined
        }
      };
      apiCommonSite(param).then(res => {
        const { code, data } = res;
        if (code === 200) {
          this.outletsList = (data.records || []).filter(item => item.siteStatus === 1);
        }
      });
    },
    // 导入添加、修改费用
    changeFeeList(type) {
      if (type === true) {
        this.selectData = [];
        this.selectedAmount = 0;
        this.tableKey = new Date().getTime();
        this.getARGenerationTableData();
      }
      this.showModification = false;
    },
    // 打开批量添加修改费用弹窗
    importFees(type) {
      this.expensesType = type;
      this.showModification = true;
    },
    // 导入计算价格
    importPrice(data) {
      // 调用接口？
      this.importData = data;
      this.showManage1 = new Date().getTime();
      this.recalculate = true;
    },
    // 打开导入计算价格模板弹窗
    getImportTemplate(type) {
      this.importData = [];
      this.calculationType = type;
      this.showImportTemplate = true;
    },
    /**
     * 费用详情、编辑
     * feeSource 0 费用 1 快录
     */
    editFee(row) {
      if (row) {
        this.queryFeeParam = cloneDeep(row);
        const timestamp = new Date().getTime();

        if (this.queryFeeParam.feeSource === 0) {
          this.addType = 2;
          this.batchAddKey = timestamp;
          this.showBatchAdd = true;
        } else {
          // 快录
          const param = { ...this.queryFeeParam };
          apiGetSubsByWaybillNumber(param)
            .then(res => {
              if (res.code === 200) {
                this.expenseSubList = res.data.expenseSubList;
                this.snapshotFeeKey = timestamp;
              }
            })
            .catch(err => {
              console.error('API 调用失败:', err);
            });

          if (typeof this.queryFeeParam.waybillNumber === 'string') {
            this.queryFeeParam.waybillNumber = this.queryFeeParam.waybillNumber.replace('QR', '');
          } else {
            console.warn('waybillNumber 不是字符串类型，无法替换 QR');
          }

          this.showAddSnapshotFee = true;
        }
      }
      // if (row) {
      //   this.queryFeeParam = cloneDeep(row);
      //   if (this.queryFeeParam.feeSource === 0) {
      //     this.addType = 2;
      //     this.batchAddKey = new Date().getTime();
      //     this.showBatchAdd = true;
      //   } else {
      //     const param = cloneDeep(this.queryFeeParam);
      //     apiGetSubsByWaybillNumber(param).then(res => {
      //       if (res.code === 200) {
      //         this.expenseSubList = res.data.expenseSubList;
      //         this.snapshotFeeKey = new Date().getTime();
      //       }
      //     });
      //     this.queryFeeParam.waybillNumber = this.queryFeeParam.waybillNumber.replace('QR', '');
      //     this.showAddSnapshotFee = true;
      //   }
      // }
    },

    // 确定删除费用
    saveDeleteRow(type) {
      if (type === 2) {
        if (!this.feeTypeName) {
          this.$message.warning(this.$i18n.t('receivablePayable.TheChargeTypeCannotBeEmpty')); // '费用类型不能为空'
          return;
        }
        const ids = [];
        if (this.selectData.length > 0) {
          this.selectData.map(item => {
            ids.push(item.id);
          });
        }
        const param = {
          ...this.queryForm.params,
          ids
        };
        param.feeCode = this.feeTypeName;
        this.$confirm(this.$i18n.t('receivablePayable.ConfirmDeletionAllDataForSelectedExpenseType'), this.$i18n.t('basicData.tips'), { // '确认删除所选费用类型的所有数据？' 提示
          confirmButtonText: this.$i18n.t('basicData.determine'), // '确定',
          cancelButtonText: this.$i18n.t('basicData.Cancel'), // '取消',
          type: 'warning'
        }).then(() => {
          apiSiteExpenseDeleteFeeSub(param).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$i18n.t('basicData.TheOperationSucceeded')); // 操作成功
              this.showDeleteRow = false;
              this.selectData = [];
              this.selectedAmount = 0;
              this.tableKey = new Date().getTime();
              this.getARGenerationTableData();
            }
          });
        }).catch(() => {
        });
      } else {
        this.showDeleteRow = false;
      }
    },
    // 打开删除费用弹窗
    deleteRow() {
      this.showDeleteRow = true;
    },
    // 关闭重新计算价格弹窗
    changePage(type) {
      this.importData = [];
      this.recalculate = false;
      this.showImportTemplate = false;
      if (type === true) {
        this.selectData = [];
        this.selectedAmount = 0;
        this.tableKey = new Date().getTime();
        this.getARGenerationTableData();
      }
    },
    // 复制批次号
    copyBatchNumber(type) {
      if (type === 1) {
        this.showGenerate = false;
        this.batchNumber = [];
        return false;
      }
      const input = document.getElementById('message5');
      const num = [];
      this.batchNumber.map(item => {
        num.push(item.split('~')[0]);
      });
      input.value = num.join(','); // 修改文本框的内容
      input.select(); // 选中文本
      document.execCommand('copy'); // 执行浏览器复制命令
      this.$message.success(this.$i18n.t('orderCenterCont.ReplicationSucceeded')); // '复制成功'
    },
    // 批量添加费用保存
    saveForm(type) {
      if (type === 2) {
        this.selectData = [];
        this.selectedAmount = 0;
        this.tableKey = new Date().getTime();
        this.getARGenerationTableData();
      }
      this.showBatchAdd = false;
    },
    // 保存、关闭添加快录弹窗
    saveFormSnapshot(type) {
      if (type === 2) {
        this.selectData = [];
        this.tableKey = new Date().getTime();
        this.getARGenerationTableData();
      }
      this.showAddSnapshotFee = false;
    },
    // rowKey
    getRowKey(row) {
      return row.id;
    },
    // 保存备注
    saveRemarks(type) {
      if (type === 1) {
        this.showAddNotes = false;
        this.remarks = '';
        return;
      }
      if (!this.remarks) {
        this.$message.warning(this.$i18n.t('receivablePayable.TheCommentCannotBeEmpty')); // '备注不能为空'
        return;
      }
      const ids = [];
      if (this.selectData.length > 0) {
        this.selectData.map(item => {
          ids.push(item.id);
        });
      }
      const param = {
        condition: this.queryForm.params,
        remark: this.remarks
      };
      param.condition.ids = ids;
      apiSetRemark(param).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$i18n.t('basicData.TheOperationSucceeded')); // '保存成功'
          this.remarks = '';
          this.selectData = [];
          this.selectedAmount = 0;
          this.tableKey = new Date().getTime();
          this.getARGenerationTableData();
          this.showAddNotes = false;
        }
      }).catch(err => {
        console.error(err);
      });
    },
    // 查看操作日志
    // operationBtnLog(data) {
    //   this.checkData = data;
    //   this.keyJournal = new Date().getTime();
    //   this.showJournal = true;
    // },
    /**
     * 生成应收
     * @param type 1 取消 2 确定
     */
    determineReceivables(type) {
      const ids = [];
      if (this.selectData.length > 0) {
        this.selectData.map(item => {
          ids.push(item.id);
        });
      }
      // 关闭弹窗
      if (type === 1) {
        this.generateReceivables = false;
        this.$refs.receivableForm.resetFields();
        return;
      }
      // 确定生成应收
      const paramForm = cloneDeep(this.queryForm.params);
      this.$refs.receivableForm.validate((valid) => {
        if (valid) {
          console.log('submit!');
          if (this.receivableForm.timeCollection && this.receivableForm.timeCollection.length > 0) {
            const flag = checkSameMonth(this.receivableForm.timeCollection);
            // 检查是否同一年月
            if (!flag) {
              this.$message.warning(this.$t('receivablePayable.dateRangeSameMonthValidation'));
              return;
            }
            paramForm.nameStartTime = this.receivableForm.timeCollection[0];
            paramForm.nameEndTime = this.receivableForm.timeCollection[1];

            const tips = ids.length > 0
              ? this.$t('receivablePayable.AreYouSureGenerateReceivablesSelectedData') // 确定给选中数据生成应收？
              : this.$t('receivablePayable.UncheckedDataWillGenerateReceivablesAllDataQueried'); // '未勾选数据将会给查询到的所有数据都生成应收，确定生成应收？';
            this.$confirm(tips, this.$t('basicData.tips'), // '提示'
              {
                confirmButtonText: this.$t('basicData.determine'), // '确定',
                cancelButtonText: this.$t('basicData.Cancel'), // '取消',
                type: 'warning'
              }
            ).then(() => {
              apiGenerateBillNumber({
                ...paramForm,
                statementType: this.receivableForm.statementType,
                ids: ids
              }).then(res => {
                if (res.code === 200) {
                  this.generateReceivables = false;
                  this.showGenerate = true;
                  this.batchNumber = res.data; // 批次号
                  this.selectData = [];
                  this.tableKey = new Date().getTime();
                  this.getARGenerationTableData();
                  this.$refs.receivableForm.resetFields();
                }
              }).catch(err => {
                console.error(err);
              });
            });
          }
        } else {
          console.log('error submit!!');
        }
      });
    },
    /**
     * 操作按钮
     * @param type 1 批量添加费用 2 批量修改费用 3 生成应收 5 备注 7 重算
     */
    operationBtn(type) {
      // const ids = this.selectData.map(item => item.id);
      const { businessType, customerIdList } = this.queryForm.params;
      if (this.tableData.length === 0) {
        this.$message.warning(this.$t('receivablePayable.businessTimeOrOrderNumberCannotBeEmpty'));
        return;
      }
      console.log('this.tableData', businessType, customerIdList);
      const isInvalid = () => {
        // 检验客户
        if (!customerIdList.length || customerIdList.length > 1) {
          this.$message.warning(this.$t('receivablePayable.PleaseFilterBusinessCustomer')); // 请筛选相同业务类型同一客户的数据进行批量添加费用
          return true;
        }
        // 检验业务类型
        if (businessType === null || businessType === '' || businessType === undefined) {
          this.$message.warning(this.$t('receivablePayable.PleaseFilterBusinessCustomer')); // 请筛选相同业务类型同一客户的数据进行批量添加费用
          return true;
        }
        return false;
      };
      // 批量添加费用
      if (type === 1) {
        if (isInvalid()) {
          return;
        }
        this.addType = 1;
        this.queryFeeParam = {
          billingMethod: this.tableData[0].billingMethod
        };
        this.showBatchAdd = true;
        this.batchAddKey = new Date().getTime();
        return;
      }
      // 批量修改费用
      if (type === 2) {
        // const { businessType, customerId } = this.queryForm.params;
        // if (!businessType && !customerId) {
        //   this.$message.warning(this.$t('receivablePayable.filterSameBusinessTypeAndCustomerForBatchModify')); // 请筛选相同业务类型同一客户的数据进行批量修改费用
        //   return;
        // }
        if (isInvalid()) {
          return;
        }
        this.$refs.modifyFeeRef.open();
        return;
      }
      // 应收生成
      if (type === 3) {
        this.generateReceivables = true;
        return;
      }
      // 添加备注
      if (type === 5) {
        this.remarks = '';
        this.showAddNotes = true;
        return;
      }
      // 重新计算价格
      if (type === 7) {
        let msg = '';
        if (this.selectData.length > 0) {
          this.calculationType = 1;
          msg = this.$i18n.t('receivablePayable.PressRecalculateWithChecked');
        } else {
          this.calculationType = 0;
          msg = this.$i18n.t('receivablePayable.Recalculate');
        }
        // 按结果计算
        if (this.queryForm.params.businessType === 1) {
          if (this.queryForm.params.collectionCategory === null) {
            // 业务类型为揽收时揽收类别不能为空
            this.$message.warning(this.$t('receivablePayable.BusinessTypePickupPickupCategoryCannotEmpty'));
            return;
          }
        }
        // if (this.queryForm.params.collectionCategory === 1) {
        //   const time1 = this.queryForm.params.startTime.split(' ')[0];
        //   const time2 = this.queryForm.params.endTime.split(' ')[0];
        //   if (time1 !== time2) {
        //     // 揽收类别为备货揽收时只能重新计算一天时间内的费用
        //     this.$message.warning(this.$t('receivablePayable.WhenPickupCategoryStockingPickup'));
        //     return;
        //   }
        // }

        this.$confirm(
          msg, // 点击”确认“按钮，将按照系统最新价格表对当前查询的所有“费用来源”为“系统生成”的费用进行重新核算，是否确认？
          this.$t('basicData.tips'),
          {
            confirmButtonText: this.$i18n.t('basicData.determine'), // '确定',
            cancelButtonText: this.$i18n.t('basicData.Cancel'), // '取消',
            type: 'warning'
          }
        ).then(() => {
          this.showManage1 = new Date().getTime();
          this.recalculate = true;
        }).catch(() => {
        });
      }
    },
    // 搜索
    searchResources() {
      this.showSearch = true;
    },
    // 查询
    searchFun(params) {
      Object.assign(this.queryForm.params, { ...params });
      this.tableKey = new Date().getTime();
      this.showSearch = false;
      this.getARGenerationTableData();

      console.log('查询', params, this.queryForm);
    },
    // 获取列表
    getARGenerationTableData() {
      const param = cloneDeep(this.queryForm);
      param.params.ids = [];
      this.getCurrentColumns = [];
      // 获取列表数据
      apiSiteExpenseGetPage(param).then(resp => {
        if (resp.code === 200) {
          if (!resp.data.length) {
            this.$message.warning(this.$t('collectionCenter.nullMsg')); // '暂无数据'
            return;
          }
          this.tableData = resp.data.map(arr => {
            if (arr.payType === 1) {
              arr.payType = 'OffLine';
            } else if (arr.payType === 0) {
              arr.payType = 'OnLine';
            } else {
              arr.payType = '';
            }
            // 物流订单 WAYBILL_STATUS    揽收订单 ORDER_TYPE_LIST  备货揽收订单 BH_ORDER_TYPE_LIST
            if ((arr.businessType === 0 || arr.businessType === 7) && arr.status) {
              /**
               * 1、业务类型 businessType 为 0，订单状态展示【物流订单】的运单状态
               */
              const s1 = this.WAYBILL_STATUS.find(item => item.code === arr.status) || '';
              arr.status = s1.label;
            } else if (arr.businessType === 1 && arr.collectionCategory === 0 && arr.status) {
              /**
               * 2、业务类型 businessType 为 1，且揽收类别 collectionCategory 为 0，订单状态展示【揽收订单】的订单状态
               */
              const s2 = this.ORDER_TYPE_LIST.find(item => item.collectStatus === arr.status) || '';
              arr.status = s2.collectStatusName;
            } else if (arr.businessType === 1 && arr.collectionCategory === 1 && arr.status) {
              /**
               * 3、业务类型 businessType 为 1，且揽收类别 collectionCategory 为 1，订单状态展示【备货揽收订单】的订单状态
               */
              const s3 = this.BH_ORDER_TYPE_LIST.find(item => item.collectStatus === arr.status) || '';
              arr.status = s3.collectStatusName;
            } else {
              arr.status = '';
            }
            arr.billType = BILL_TYPE[arr.billType].name;
            return arr;
          });

          this.total = resp.total;
          if (resp.data.length > 0) {
            this.getCurrentColumns = [];
            resp.columns.map(item => {
              const obj = {
                prop: item.prop,
                label: item.label,
                width: 160,
                fixed: 'left',
                highlight: false
              };
              this.getCurrentColumns.push(obj);
              this.$nextTick(() => {
                this.$refs.table.doLayout();
                this.rowSelectFlag = true;
                this.tableData.map(list => {
                  const matchedIndex = this.selectData.findIndex(itemList => itemList.id === list.id);
                  this.$refs.table.toggleRowSelection(list, matchedIndex !== -1);
                });
                this.rowSelectFlag = false;
              });
            });
          }
        }
      }).catch(() => {});
    },
    // 列表数据勾选
    handleSelectionChange(arr) {
      if (this.rowSelectFlag) return;
      this.selectData = [];
      this.selectedAmount = 0;
      this.selectData = arr; // deWeight(arr);
      if (this.selectData.length === 0) {
        this.selectedAmount = 0;
      } else {
        this.selectData.map(item => {
          this.selectedAmount = item.receivablesRmb ? Number(item.receivablesRmb) + this.selectedAmount : this.selectedAmount;
        });
      }
    },
    // 单号批量删除费用
    delOrder() {
      this.showBatchDeleteExpensesByOrderNo = true;
      this.batchDeleteExpensesByOrderNo = new Date().getTime();
    },
    importDelOrder(data) {
      console.log(data);
      apiPayableSiteExpenseDeleteFee(data).then(res => {
        if (res.code === 200) {
          this.showBatchDeleteExpensesByOrderNo = false;
          // this.$message({
          //   message: this.$i18n.t('basicData.TheOperationSucceeded'),
          //   type: 'success'
          // });
          goFileUploadManagement(this);
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
.searchBox {
  display: flex;
  align-content: center;
  justify-content: space-between;
  /* border: 1px solid #000; */
}

.searchBox > div {
  display: flex;
  align-content: center;
}
</style>
